export default "__VITE_ASSET__Fva1JlYr__"